'use client';
/*
 * Documentation:
 * Loadign — https://app.subframe.com/6fc7f5fbb098/library?component=Loadign_d5e20aa7-9627-4073-911a-8e979a3ad176
 */

import React from 'react';
import * as SubframeUtils from '../utils';

interface LoadignRootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  progress?: React.ReactNode;
  className?: string;
}

const LoadignRoot = React.forwardRef<HTMLDivElement, LoadignRootProps>(function LoadignRoot(
  { icon, title, description, progress, className, ...otherProps }: LoadignRootProps,
  ref,
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        'bg-default-background flex w-full max-w-[448px] min-w-[320px] flex-col items-center justify-center gap-6 rounded-md border border-solid border-neutral-200 px-8 py-12 shadow-lg',
        className,
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex w-full flex-col items-center gap-2">
        {icon ? <img className="flex-none" src={icon} /> : null}
        {title ? (
          <span className="text-heading-2 font-heading-2 text-default-font w-full text-center">
            {title}
          </span>
        ) : null}
        {description ? (
          <span className="text-body font-body text-subtext-color w-full text-center">
            {description}
          </span>
        ) : null}
      </div>
      {progress ? (
        <div className="flex w-full flex-col items-center justify-center gap-6">{progress}</div>
      ) : null}
    </div>
  );
});

export const Loadign = LoadignRoot;
